import { c as _c } from "react/compiler-runtime";
import { FaCreditCard } from "react-icons/fa";
import { LiaCcAmex } from "react-icons/lia";
import { RiBankFill, RiMastercardLine, RiVisaLine } from "react-icons/ri";
import { SiApplepay } from "react-icons/si";
import { SiDiscover } from "react-icons/si";
import { Tooltip } from "@/components/ui";
import { cx } from "@/lib/tailwind-utils";
import { PaymentMethod } from "@/types/payment";
type PaymentMethodCard = Pick<PaymentMethod, "type" | "brand" | "bankName">;
interface CardIconProps {
  paymentMethod: PaymentMethodCard;
  className?: string;
  size?: number;
}
const CardIcon = t0 => {
  const $ = _c(43);
  const {
    paymentMethod,
    className,
    size: t1
  } = t0;
  const size = t1 === undefined ? 22 : t1;
  if (paymentMethod.type === "APPLE_PAY") {
    let t2;
    if ($[0] !== className) {
      t2 = cx(className, "text-foreground");
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== size || $[3] !== t2) {
      t3 = <SiApplepay className={t2} size={size} />;
      $[2] = size;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  if (paymentMethod.type === "ACH") {
    const t2 = paymentMethod.bankName;
    let t3;
    if ($[5] !== className) {
      t3 = cx(className, "text-foreground");
      $[5] = className;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== size || $[8] !== t3) {
      t4 = <RiBankFill className={t3} size={size} />;
      $[7] = size;
      $[8] = t3;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] !== paymentMethod.bankName || $[11] !== t4) {
      t5 = <Tooltip content={t2}>{t4}</Tooltip>;
      $[10] = paymentMethod.bankName;
      $[11] = t4;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    return t5;
  }
  if (!paymentMethod.brand) {
    let t2;
    if ($[13] !== className) {
      t2 = cx(className, "text-foreground");
      $[13] = className;
      $[14] = t2;
    } else {
      t2 = $[14];
    }
    let t3;
    if ($[15] !== size || $[16] !== t2) {
      t3 = <FaCreditCard className={t2} size={size} />;
      $[15] = size;
      $[16] = t2;
      $[17] = t3;
    } else {
      t3 = $[17];
    }
    return t3;
  }
  switch (paymentMethod.brand.toLowerCase()) {
    case "visa":
      {
        let t2;
        if ($[18] !== className) {
          t2 = cx(className, "text-foreground");
          $[18] = className;
          $[19] = t2;
        } else {
          t2 = $[19];
        }
        let t3;
        if ($[20] !== size || $[21] !== t2) {
          t3 = <RiVisaLine className={t2} size={size} />;
          $[20] = size;
          $[21] = t2;
          $[22] = t3;
        } else {
          t3 = $[22];
        }
        return t3;
      }
    case "mastercard":
      {
        let t2;
        if ($[23] !== className) {
          t2 = cx(className, "text-foreground");
          $[23] = className;
          $[24] = t2;
        } else {
          t2 = $[24];
        }
        let t3;
        if ($[25] !== size || $[26] !== t2) {
          t3 = <RiMastercardLine className={t2} size={size} />;
          $[25] = size;
          $[26] = t2;
          $[27] = t3;
        } else {
          t3 = $[27];
        }
        return t3;
      }
    case "amex":
    case "american_express":
      {
        let t2;
        if ($[28] !== className) {
          t2 = cx(className, "text-foreground");
          $[28] = className;
          $[29] = t2;
        } else {
          t2 = $[29];
        }
        let t3;
        if ($[30] !== size || $[31] !== t2) {
          t3 = <LiaCcAmex className={t2} size={size} />;
          $[30] = size;
          $[31] = t2;
          $[32] = t3;
        } else {
          t3 = $[32];
        }
        return t3;
      }
    case "discover":
      {
        let t2;
        if ($[33] !== className) {
          t2 = cx(className, "text-foreground");
          $[33] = className;
          $[34] = t2;
        } else {
          t2 = $[34];
        }
        const t3 = size + 12;
        let t4;
        if ($[35] !== t2 || $[36] !== t3) {
          t4 = <SiDiscover className={t2} size={t3} />;
          $[35] = t2;
          $[36] = t3;
          $[37] = t4;
        } else {
          t4 = $[37];
        }
        return t4;
      }
    default:
      {
        let t2;
        if ($[38] !== className) {
          t2 = cx(className, "text-foreground");
          $[38] = className;
          $[39] = t2;
        } else {
          t2 = $[39];
        }
        let t3;
        if ($[40] !== size || $[41] !== t2) {
          t3 = <FaCreditCard className={t2} size={size} />;
          $[40] = size;
          $[41] = t2;
          $[42] = t3;
        } else {
          t3 = $[42];
        }
        return t3;
      }
  }
};
export default CardIcon;